import { HttpInterceptorFn } from '@angular/common/http';
import { of } from 'rxjs';
import { delay, switchMap } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { mockHandlers } from '../mocks/mock.providers';


/** Simulated network latency, so loading states are actually visible. */
const MOCK_LATENCY_MS = 500;

/**
 * Answers requests that match a registered {@link MockHandler}; everything
 * else passes through to the real API. Register first in the interceptor
 * chain so mocked requests short-circuit before auth runs.
 */
export const mockInterceptor: HttpInterceptorFn = (req, next) => {
  if (!environment.useMocks) {
    return next(req);
  }

  const handler = mockHandlers.find(h => h.matches(req));

  if (!handler) {
    return next(req);
  }

  console.debug('[mock] intercepted', req.method, req.url);
  return of(null).pipe(
    delay(MOCK_LATENCY_MS),
    switchMap(() => handler.respond(req))
  );
};